import { useTranslations } from "../../contexts/Translation";
import { useNotifications } from "../../contexts/Notifications";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import Link from "../Link/Link";
import styles from "./Layout.module.css";

const Bell = () => (
  <svg viewBox='0 0 24 24' width='22' height='22' aria-hidden='true' focusable='false'>
    <path
      d='M12 3a6 6 0 0 0-6 6v3.6L4.3 15.5A1 1 0 0 0 5.2 17h13.6a1 1 0 0 0 .9-1.5L18 12.6V9a6 6 0 0 0-6-6Zm-2 15a2 2 0 0 0 4 0'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinejoin='round'
    />
  </svg>
);

export const TopBar = () => {
  const t = useTranslations("menu");
  const { unreadCount } = useNotifications();

  return (
    <header className={styles.topBar}>
      <Link
        className={styles.bell}
        href='/notifications'
        aria-label={unreadCount > 0 ? t("unreadNotifications", unreadCount) : t("notifications")}
      >
        <Bell />
        {unreadCount > 0 && <span className={styles.bellDot} />}
      </Link>
      <Link className={styles.createButton} href='/survey'>
        {t("createSurvey")}
      </Link>
      <HamburgerMenu />
    </header>
  );
};
